export const base_routes = {
    LOGIN : 'login',
    LANDING_PAGE: 'landingpage',
    HOME: 'home',
    WORKING_HOURS: 'working_hours',
    USER : 'user',
    DASHBOARD : 'dashboard',
    FORGOTPASSWORD:"forgotpassword"
}